<template>
  <div v-if="list.length > 0">
    <!-- 循环条件 -->
    <div v-for="(item, index) in rowLength" :key="index">
      <div class="list-child">
        <div class="btns-con" v-if="index == 0" style="margin-right: 15px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            @click="handleAdd(item, index)"
            size="small"
          ></el-button>
          <el-button
            slot="reference"
            icon="el-icon-minus"
            circle
            size="small"
            @click="handleDel(item, index)"
            style="margin-left: 25px; background: #ccc; border: 1px solid #ccc"
          ></el-button>
        </div>
        <div style="margin-right: 15px; width: 100px" v-else>
          <el-select
            slot="prepend"
            placeholder="请选择"
            v-model="list[index * 2 - 1]['type']"
          >
            <el-option
              :label="i.label"
              :value="i.id"
              v-for="(i, index2) in selectList_2"
              :key="index2"
            ></el-option>
          </el-select>
        </div>
        <div style="flex: 1">
          <el-input placeholder="请输入内容" :maxlength="500" v-model="list[index * 2]['value']">
            <el-select
              slot="prepend"
              placeholder="请选择"
              v-model="list[index * 2]['field']"
            >
              <el-option
                :label="i.label"
                :value="i.id"
                v-for="(i, index0) in selectList_0"
                :key="index0"
              ></el-option>
            </el-select>
            <el-select
              slot="append"
              placeholder="请选择"
              v-model="list[index * 2]['compare']"
            >
              <el-option
                :label="i.label"
                :value="i.id"
                v-for="(i, index1) in selectList_1"
                :key="index1"
              ></el-option>
            </el-select>
          </el-input>
        </div>
        <div
          class="btns-con btns-con-append"
          v-if="index == 0"
          style="width: 122px; margin-left: 15px"
        >
          <el-button
            type="primary"
            size="small"
            @click="pushDataToParent()"
            icon="el-icon-search"
          ></el-button>
          <el-button type="primary" size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["selectType", "currentKey", "checkedTreeObj"],
  data() {
    return {
      selectList_0: [], //下拉框数据 ---篇名/关键词
      selectList_1: [], //下拉框数据  --- 精准/模糊
      selectList_2: [], //下拉框数据  --- 并且 /或者
      selectList_0_default: undefined, //默认选择
      selectList_1_default: undefined,
      list: [], //需要传给后台数据
      reviewType: window.localStorage.getItem("reviewType"), //审查类型：条目审查/整篇审查
    };
  },
  computed: {
    rowLength() {
      if (this.list) {
        return (this.list.length + 1) / 2;
      } else {
        return [];
      }
    },
  },
  watch: {
    list: {
      immediate: true,
      handler: function (val) {
        this.$emit("input", val);
      },
    },
    selectType: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getAdvanceList();
        }
      },
    },
  },
  methods: {
    // 根据一级标签获取高级检索下拉框数据-初始化
    getAdvanceList() {
      let selectType;
      let item_id;
      //默认情况下currentKey为整篇的uuid //章的时候推全篇 tag=c
      if (this.currentKey.indexOf("_") < 0 || this.checkedTreeObj.tag == "c") {
        console.log("篇");
        item_id = "";
      } else {
        console.log("条");
        item_id = this.currentKey;
      }
      if (this.selectType == "CLKL") {
        selectType = item_id || this.reviewType == "item" ? "CLKLT" : "CLKLP";
      } else {
        selectType = this.selectType;
      }
      this.axios.get(`/japi/lawAIRec/getfield?from=${selectType}`).then((res) => {
        if (res.data.code == 200) {
          const { data } = res.data;
          this.selectList_0 = data[0].child;
          this.selectList_1 = data[1].child;
          this.selectList_2 = data[2].child;

          // 设置默认值
          this.selectList_0_default = data[0].child.filter(
            (item) => item.remark == "default"
          )[0].id;
          this.selectList_1_default = data[1].child[0].id;
          this.list = [
            {
              field: data[0].child.filter((item) => item.remark == "default")[0].id,
              value: undefined,
              compare: data[1].child[0].id,
            },
          ];
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    handleAdd(item, index) {
      let listLength = (this.list.length + 1) / 2;
      if (listLength >= this.selectList_0.length) {
        this.$message({
          message: `最多添加${this.selectList_0.length}个条件！`,
          type: "warning",
        });
        return;
      }

      this.list.splice(
        this.list.length + 1,
        0,
        {
          type: "and",
        },
        {
          field: this.selectList_0_default,
          value: undefined,
          compare: this.selectList_1_default,
        }
      );
    },
    // 删除按钮
    handleDel(item, index) {
      if (this.list.length === 1) {
        this.$message({
          message: "当前条件不能删除！",
          type: "warning",
        });
        return;
      }
      this.list.splice(this.list.length - 2, 2);
    },
    pushDataToParent() {
      this.$emit("advanceFormChange", this.list);
    },
    reset() {
      this.list = [
        {
          field: this.selectList_0_default,
          value: undefined,
          compare: this.selectList_1_default,
        },
      ];
      this.$emit("advanceFormChange", undefined);
    },
  },
};
</script>
<style>
.list-child {
  display: flex;
  margin-bottom: 10px;
}
.list-child > div:nth-of-type(1) {
  width: 100px;
}
.list-child .el-input-group__prepend {
  background: #fff;
  width: 65px;
}
.list-child .el-input-group__append {
  background: #fff;
  width: 40px;
}
.list-child .el-input {
  width: 100%;
}
.list-child .el-button {
  background: #f59500;
  border-color: #f59500;
  color: #fff;
}
.btns-con-append .el-button {
  width: 56px;
  height: 32px;
  box-sizing: border-box;
  position: relative;
}
.btns-con-append .el-button:nth-of-type(2) {
  position: relative;
  top: -3px;
}
.btns-con-append .el-button i {
  font-size: 20px;
  margin-top: -4px;
}
.btns-con {
  width: 110px;
}
.list-child .el-input__inner {
  height: 34px !important;
  font-size: 14px !important;
  color: #909399;
}
</style>
